import { useModal } from '@shared/model/useModal';

export const useConnectStudentModal = () => useModal('connect-student')